import { Button, Grid, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from "@mui/material";
import { UnfoldMore as UnfoldMoreIcon } from '@mui/icons-material';
import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import PubSub from "pubsub-js";
import HintDialog, { OPEN_HINT_DIALOG } from "../Component/HintDialog";
import ActionDialog, { OPEN_ACTION_DIALOG } from "../Component/ActionDialog";
import { sessionOptions } from "./Home";
import { labelData } from "../utils";

function CheckList () {
  const [data, setData] = useState([]);
  const [id, setId] = useState(1);
  const [value, setValue] = useState('');
  const [sortType, setSortType] = useState();
  const navigate = useNavigate();

  const changeId = newId => () => {
    setId(newId);
    getData(newId);
  }

  const getData = async (id) => {
    const passData = {api: 'user_session', action: 'list', _session_id: id};
    const url = process.env.NODE_ENV === 'development' ? `http://${document.location.hostname}/check-in/public/api/` : '/api/';
    const response = await axios.post(url, passData);
    const columns = response.data.data?.columns;
    const rows = response.data.data?.rows;
    if (rows && rows.length) {
      setData(rows.map(row => labelData(columns, row)));
    }
  }

  useEffect(() => {
    if (!sortType) return;
    const newData = [...data];
    newData.sort((a, b) => {
      if (sortType === 'byName') {
        return a.name[0].localeCompare(b.name[0]);
      }
      
      // let result = true;
      // if (sortType === 'byStartTime') {
      //   result = new Date(a.start_date + ' ' + a.start_time) > new Date(b.start_date + ' ' + b.start_time);
      // }else {
      //   result =  new Date(a.end_date + ' ' + a.end_time) > new Date(b.end_date + ' ' + b.end_time);
      // }
      // return result ? 1 : -1;

      if (sortType === 'byHasCheck') {
        return Number(b.has_check) - Number(a.has_check)
      }
    });
    setData(newData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sortType])

  useEffect(() => {
    getData(id);
  }, [])

  const toHome = () => {
    navigate('../');
  }

  const withdrawCheckIn = (row) => () => {
    const content = <>
      <Typography>姓名: {row.name}</Typography>
      <Typography>電話: {row.phone}</Typography>
      <Typography>報到時間: {row.check_in_time}</Typography>
      <Typography>活動: {sessionOptions.find(({_id}) => _id === id).label}</Typography>
      <Typography>確定撤回報到?</Typography>
    </>
    const onConfirm = () => async () => {
      const passData = {api: 'user_session', action: 'withdrawCheckIn', _session_id: row._session_id, _user_id: row._user_id};
      const url = process.env.NODE_ENV === 'development' ? `http://${document.location.hostname}/check-in/public/api/` : '/api/';
      const response = await axios.post(url, passData);
      getData(id);
    }
    PubSub.publish(OPEN_ACTION_DIALOG, {content, onConfirm})
  }

  return (
    <>
    <Grid container>
      <Grid size={6}><Button onClick={changeId(1)}>2026-07-31 金剛力灌頂</Button></Grid>
      <Grid size={6}><Button onClick={changeId(2)}>2026-08-01 時輪金剛灌頂、大鵬金翅鳥灌頂</Button></Grid>
      <Grid size={6}><Button onClick={changeId(3)}>2026-08-01 時輪金剛、香巴拉與世界和平國際論壇</Button></Grid>
      <Grid size={6}><Button onClick={changeId(4)}>2026-08-02 篤布巴暨時輪九尊世界和平祈福大法會</Button></Grid>
      <Grid size={3}><Button onClick={toHome}>返回</Button></Grid>
    </Grid>
    <TextField fullWidth label={'搜尋姓名'} defaultValue={value} onChange={e => setValue(e.target.value)}></TextField>
    <Table>
      <TableHead>
        <TableRow>
          <TableCell width={"25%"}>
            <Button sx={{p: 0, color: 'black'}} onClick={() => setSortType('byName')}>
              <Typography>
                姓名
              </Typography>
              {sortType === 'byName' && <UnfoldMoreIcon/>}
            </Button>
          </TableCell>
          <TableCell width={"25%"}>人數</TableCell>
          <TableCell width={"25%"}>
            <Button sx={{p: 0, color: 'black'}} onClick={() => setSortType('byHasCheck')}>
              <Typography>
                報到狀態
              </Typography>
              {sortType === 'byHasCheck' && <UnfoldMoreIcon/>}
            </Button>
          </TableCell>
          <TableCell width={"25%"}>報到時間</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {data.length > 0 && data.filter(({name}) => name.includes(value)).map((row, i) => {
          return (
            <TableRow key={i}>
              <TableCell>{row.name}</TableCell>
              <TableCell>{row.person_count}</TableCell>
              <TableCell>{row.has_check ? <Button onClick={withdrawCheckIn(row)}>已報到</Button> : '未報到'}</TableCell>
              <TableCell>{row.check_in_time}</TableCell>
            </TableRow>
          )
        })}
      </TableBody>
    </Table>
    <ActionDialog title={'報到撤回'}/>
    </>
  )
}

export default CheckList;